export const handleFormBlur = (e) => {
  if (!e || !e.target) return;
  if (!e.target.validity.valid && e.target.value) {
    e.target.className += ' has-error';
  }
};

export const clearFormError = (e) => {
  if (!e) return;
  if (!e.target) {
    e.className = e.target.className.replaceAll('has-error', '');
  } else {
    e.target.className = e.target.className.replaceAll('has-error', '');
  }
};
